import { mdiAccountGroup } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "customers",
  title: "Ansprechpartner",
  tooltip: "Ansprechpartner, ihre Kontaktdaten und ihre Zuordnung zu Liegenschaften verwalten.",
  icon: mdiAccountGroup,
  routeSegment: "customers",
  // Same projection as the registry read admission (kehrblatt.registry:view).
  getPages: (context) =>
    context.permissions.allows("kehrblatt.registry", "view")
      ? [
          {
            id: "customers",
            title: "Ansprechpartner",
            path: "",
          },
        ]
      : [],
}
